import styled from 'styled-components/macro';

import { rem } from 'polished';
import { rgba } from 'polished';
import { applyStyleModifiers } from 'styled-components-modifiers';

const Overlay = styled.div`
  position: fixed; /* Sit on top of the page content */
  display: ${(props) => props.display || 'none'};
  //display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  //background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  background-color: rgba(0,0,0,0.3); /* Black background with opacity */
  z-index: 1; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
`;

const ButtonWrap = styled.div`
  position: absolute;
  top: ${(props) => props.top || '0px'};
  right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4.5px 6px 4.5px 4.5px;
  background-color: white;
  border: 1px solid #C7C7CC;
  border-radius: 8px;
  height: 34px;
  z-index: 2;
`;

const Button = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 12px;
  transition: transform 0.1s ease;

  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }

  &:first-child {
    margin-left: 5px;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const WinContainer = styled.section`
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '120px'};
  position: absolute;
  z-index: 1000;

  @media (max-width: 800px) {
    left: 50px;
    min-width: 200px;
  }
`;

const Triangle = styled.span`
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '0px'};
  position: absolute;
  width: 0;
  height: 0;
  background-color: transparent;
  border-style: solid;
  border-left-width: 5px;
  border-right-width: 5px;
  border-top-width: 10px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-top-color: rgba(44,44,46,255);

`;

const WinContainerMenu = styled.section`
  position: absolute;
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '120px'};
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  min-width: 220px;
  animation: fadeInScale 150ms ease-out;
  overflow: hidden;

  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media (max-width: 600px) {
    left: 5%;
    right: 5%;
    min-width: unset;
    width: 90%;
  }
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center; // ⬅️ Vertically centers both icon and text
  gap: 10px; // ⬅️ Space between icon and text
  padding: 10px 16px;
  font-family: 'AvertaBold';
  font-size: 14px;
  color: #222;
  background-color: white;
  transition: background-color 0.2s ease;

  &:hover {
    cursor: pointer;
    background-color: #f7f7fa;
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  img.menu__icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    display: block;
    flex-shrink: 0;
  }

  span {
    line-height: 1; // ⬅️ Ensures text aligns middle with icon
    display: inline-block;
  }
`;



export default {
  WinContainer,
  Overlay,
  ButtonWrap,
  Button,
  Triangle,
  WinContainerMenu,
  MenuItem,
};
